module.exports = __webpack_public_path__ + "static/media/freedomlyFacebook-1200x630.27710de4.jpg";